export default __webpack_public_path__ + "static/media/Graphics_Postcard-02-min.edd66cc2.jpg";